export * from './IconTrashCan';
export { default as IconTrashCan } from './IconTrashCan';
